import { useState } from 'react';
import { Flex, Modal } from 'components';
import { shortenString } from './helpers';
import { StageDefault, StageDefaultHeader, StageMonth } from './components';
import './style.scss';

interface IPropsCity {
  id: string;
  name: string;
}

interface IProps {
  date: Date;
  arrivalCity: IPropsCity;
  departureCity: IPropsCity;
  onClose: () => void;
  onAccept: (date: Date) => void;
}

type Stage = 'default' | 'month';

function ModalCalendarPrice(props: IProps) {
  const minDate = new Date();
  const [stage, setStage] = useState<Stage>('default');
  const [date, setDate] = useState<Date>(props.date);

  const handleMonthSelect = (date: Date) => {
    setDate(date);
    setStage('default');
  };

  return (
    <Modal
      size={400}
      onClose={props.onClose}
      header={`${shortenString(props.departureCity.name, 20)} — ${shortenString(props.arrivalCity.name, 20)}`}
    >
      <Flex
        className='stage-OqQe'
        direction='column'
        gap={20}
      >
        {stage === 'default' && (
          <StageDefaultHeader
            date={date}
            minDate={minDate}
            onDateChange={setDate}
            onMonthClick={() => setStage('month')}
          />
        )}
        {stage === 'default' && (
          <StageDefault
            date={date}
            arrivalCityId={props.arrivalCity.id}
            departureCityId={props.departureCity.id}
            onDateClick={props.onAccept}
          />
        )}
        {stage === 'month' && (
          <StageMonth
            date={date}
            minDate={minDate}
            onSelect={handleMonthSelect}
          />
        )}
      </Flex>
    </Modal>
  );
}

export default ModalCalendarPrice;
